import React from "react";

// region External libraries
import { Person } from "@mui/icons-material";
// endregion External libraries
// region Languages
import { GlobalMessages } from "@languages/interfaces";
import useTranslation from "@languages/useTranslation";
// endregion Languages
// region Styles
import * as Styled from "./styles";
// endregion Styles

interface IUserIconProps {
  userImg?: string;
  onClick?: (event: React.MouseEvent<HTMLDivElement>) => void;
  blockMoreInfo?: boolean;
  active?: boolean;
}

const UserIcon: React.FC<IUserIconProps> = ({
  userImg,
  onClick,
  blockMoreInfo,
  active
}) => {
  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    if (blockMoreInfo) return;

    onClick && onClick(event);
  };

  const { t } = useTranslation();

  return (
    <Styled.Container>
      {!active && (<Styled.Badge>{t(GlobalMessages.inactiveText)}</Styled.Badge>)}
      <Styled.Image onClick={handleClick} blockMoreInfo={blockMoreInfo}>
        {userImg ? <img src={userImg} alt="User" /> : <Person />}
      </Styled.Image>
    </Styled.Container>
  );
};

UserIcon.defaultProps = {
  userImg: undefined,
  onClick: undefined,
  blockMoreInfo: false,
  active: true
};

export default UserIcon;
